import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import FontAwesomeIcon from "~/cabinet/vue/interface/icon/FontAwesomeIcon.vue";
import HelpBlock from "~/cabinet/vue/interface/HelpBlock.vue";
import {__} from "~/ts/library/Translate";

const __default__ = {
    name: "ServerSideConfigUsedWarning"
}

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(HelpBlock, { class: "mb-4" }, {
    default: _withCtx(() => [
      _createVNode(FontAwesomeIcon, {
        class: "text-primary mr-1",
        icon: "circle-info"
      }),
      _createTextVNode(" " + _toDisplayString(_unref(__)('У вас используются настройки, заданные из личного кабинета.')), 1)
    ]),
    _: 1
  }))
}
}

})